// UploadToolbar.js
// створення нових папок, вибір папок для завантаження файлів і завантаження

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FolderUploadButton from './FolderUploadButton';


export default function UploadToolbar({ authed, uploadLb }) {
    const [showModal, setShowModal] = useState(false);
    const currentFolderName = uploadLb?.path?.[uploadLb.path.length - 1]?.name || "";

    if (!authed) return null;

    const hasResults = uploadLb.uploadResults.length > 0;

    const openModal = () => {
        if (hasResults) setShowModal(true);
    };

    return (
        <>
            {/* Upload toolbar */}
            {currentFolderName && (
                <div className="flex flex-wrap items-center gap-2 mb-4">
                    <button
                        disabled={!authed}
                        className={[
                            "group relative inline-flex items-center gap-2 rounded-md border px-3 py-2 text-sm",
                            "shadow-sm transition active:scale-[.98] focus:outline-none focus:ring-2 focus:ring-blue-500/50",
                            !authed
                                ? "cursor-not-allowed opacity-60"
                                : "hover:bg-gray-50 dark:hover:bg-neutral-800 cursor-pointer",
                        ].join(" ")}
                        onClick={uploadLb.openFolderPicker}
                    >
                        Створити нову 📁
                    </button>

                    <FolderUploadButton
                        uploadLb={uploadLb}
                        authed={authed}
                        showFileProgress={true}
                    />

                    {hasResults && (
                        <button
                            onClick={openModal}
                            className="px-3 py-2 border rounded-md text-sm bg-gray-100 hover:bg-gray-200"
                        >
                            Переглянути результати
                        </button>
                    )}
                </div>
            )}
            {showModal && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-lg font-semibold">Результати завантаження</h2>
                            <button
                                onClick={() => setShowModal(false)}
                                className="text-gray-500 hover:text-gray-800 text-xl leading-none"
                                aria-label="Close"
                            >
                                ×
                            </button>
                        </div>

                        <div className="max-h-64 overflow-y-auto">
                            <ul className="list-disc pl-5 space-y-1 text-sm">
                                {uploadLb.uploadResults.map((r, i) => (
                                    <li key={i} className={r.ok ? 'text-green-700' : 'text-red-700'}>
                                        <span className="font-medium">{r.name}</span> —{' '}
                                        {r.ok ? (
                                            'OK'
                                        ) : (
                                            <>
                                                помилка
                                                {r.http && (
                                                    <span className="opacity-70">
                                                        {' '}
                                                        (HTTP {r.http})
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="mt-4 text-right">
                            <button
                                onClick={() => setShowModal(false)}
                                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                            >
                                Закрити
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

UploadToolbar.propTypes = {
    authed: PropTypes.bool.isRequired,
    uploadLb: PropTypes.object.isRequired,
};
